import { useLocation } from 'react-router';

export const useInRecruiterApp = (): boolean => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const isEmbedded = query.get('embedded') === '1' || window.self !== window.top;
  return isEmbedded;
};
